// [Codex 2026-07-03] Shared Chat/Voice permission labels for settings and composers.
export type PermissionLevel = "full" | "desk" | "limited";

export interface PermissionLevelOption {
  value: PermissionLevel;
  label: string;
  detail: string;
}

export const DEFAULT_PERMISSION_LEVEL: PermissionLevel = "desk";

export const permissionLevelOptions: PermissionLevelOption[] = [
  {
    value: "full",
    label: "Full Access",
    detail: "Bypass All Permissions",
  },
  {
    value: "desk",
    label: "Desk Access:",
    detail: "Auto, confirmation for discretionary tasks",
  },
  {
    value: "limited",
    label: "Limited Access",
    detail: "Asks for permission for most tasks",
  },
];

export function normalizePermissionLevel(value: unknown): PermissionLevel {
  return value === "full" || value === "limited" || value === "desk"
    ? value
    : DEFAULT_PERMISSION_LEVEL;
}

export function getPermissionLevelOption(
  value: unknown,
): PermissionLevelOption {
  const normalized = normalizePermissionLevel(value);
  return (
    permissionLevelOptions.find((option) => option.value === normalized) ??
    permissionLevelOptions[1]
  );
}
